import { render, staticRenderFns } from "./MoreMenu.vue?vue&type=template&id=6bb62715&scoped=true"
import script from "./MoreMenu.vue?vue&type=script&lang=js"
export * from "./MoreMenu.vue?vue&type=script&lang=js"
import style0 from "./MoreMenu.vue?vue&type=style&index=0&id=6bb62715&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb62715",
  null
  
)

export default component.exports